import { useTranslation as useI18nTranslation } from 'react-i18next';

/**
 * Custom hook for translations
 * Wrapper around react-i18next's useTranslation hook
 * 
 * @example
 * const { t, i18n } = useTranslation();
 * <p>{t('common.loading')}</p>
 */
export const useTranslation = () => {
  return useI18nTranslation();
};

